import React from "react";
import "./TextCarousel.scss";

function TextCarousel() {
  const words = [
    "B2B Supplier", "Retail MOQ", "Custom Labeling", "Paper Packaging", "Bulk Cartons", "Reliable",
    "Cost-Effective", "Sample Support", "Formula Options", "Flexible", "Eco-Focused",
    "Scalable", "Customization", "Refill Shop Support", "Private Label",
    "Fast Delivery", "High-quality production", "Innovative", "Efficient", "Transparent",
    "MSDS Available", "Custom Scent", "Retail Packaging", "Responsible",
    "Professional", "Lightweight", "Clean", "Logistics Support", "Documentation"
  ];

  const text = words.map((word, index) => (
    <div key={index} className="carousel-text">{word}</div>
  ));

  return (
    <div className="text-carousel-wrapper">
      <div className="text-carousel" data-text={words.join(" — ")}>
        {text}
        {text /* Duplicate for seamless loop */}
      </div>
    </div>
  );
}

export default TextCarousel;
